import { GreenWall } from '~/components/Landing/GreenWall'

export default function GreenWallPage() {
  return <GreenWall />
}